import { post } from '@core/api/baseApi';
import { GetReportConclusionResponse } from '@core/types';

const getReportConclusion = async (reportContent: string): Promise<GetReportConclusionResponse> =>
  await post(`/studies/reports/conclusion`, { reportContent });

export default getReportConclusion;
